// @mui
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
// auth
// routes
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// theme
// components
import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

type Props = {
  title?: string;
  image?: string;
  children: React.ReactNode;
};

export default function AuthClassicLayout({ children, image, title }: Props) {
  const theme = useTheme();
  const upMd = useResponsive('up', 'md');

  const renderContent = (
    <Stack
      sx={{
        width: 1,
        maxWidth: 480,
        px: { xs: 2, md: 8 },
        py: { xs: 2, md: 8 },
        backgroundColor: theme.palette.background.default,
        borderRadius: 2,
        zIndex: 2,
      }}
    >
      {children}
    </Stack>
  );

  const renderSection = (
    <Stack
      flexGrow={1}
      alignItems="center"
      justifyContent="center"
      sx={{
        background: upMd
          ? 'linear-gradient(100deg, rgb(5, 59, 93) 0%, rgb(0, 27, 52) 100%)'
          : 'inherit',
      }}
    >
      {upMd && (
        <>
          <Box
            component="img"
            src="/assets/circle-shape.png"
            sx={{ position: 'absolute', top: '-20%', left: '-13%', zIndex: 1 }}
          />
          <Box
            component="img"
            src="/assets/shape-bg.png"
            sx={{
              position: 'absolute',
              left: 0,
              bottom: 0,
              zIndex: 1,
              width: '100%',
            }}
          />
        </>
      )}

      {renderContent}
    </Stack>
  );

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        height: '100vh',
      }}
    >
      {renderSection}
    </Stack>
  );
}
